import { Object3D, Euler, Quaternion, Vector3, AxisHelper } from 'three';
import { Model } from './Model';

export class EntityDependency extends Model{
	constructor(viewer, modelName, data, product){
		super(viewer, modelName, data);

		this.product = product;
	}

	async load(){
		const obj = await this.viewer.load(`/storage/models/${this.modelName}`);

		if(obj){
			this.wrapper.add(obj.clone());
			this.loadComplete();
		}
	}

	layout(){

		if(!this.data) return;

		if(this.data.hasOwnProperty('dependency_scale')){
			this.wrapper.scale.set(
				this.data.dependency_scale,
				this.data.dependency_scale,
				this.data.dependency_scale
			);
		}

		this.rotation.set(0,0,0);

		if(this.data.hasOwnProperty('dependency_anchor')
		&& this.data.hasOwnProperty('entity_anchor')){
			this.layoutWrapper.position.set(
				-this.data.dependency_anchor.position.x,
				-this.data.dependency_anchor.position.y,
				-this.data.dependency_anchor.position.z
			);

			this.position.set(
				this.data.entity_anchor.position.x,
				this.data.entity_anchor.position.y,
				this.data.entity_anchor.position.z,
			);

			const entityDir = new Vector3().copy(this.data.dependency_anchor.direction);
			const sceneDir 	= new Vector3().copy(this.data.entity_anchor.direction).negate();

			if(entityDir.length() != 0 && sceneDir.length() != 0){
				this.quaternion.setFromUnitVectors(entityDir, sceneDir);
			}
			
			if(this.data.hasOwnProperty('dependency_rotation')){
				this.rotateOnAxis(this.data.entity_anchor.direction, this.data.dependency_rotation * Math.PI / 180);
			}
		}

	}
}